import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store';
import ElementUI from 'element-ui'
import axios from '../node_modules/axios'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.less'
import '@/assets/css/font-awesome-4.7.0/css/font-awesome.min.css'
import '@/assets/css/index.css'
import '@/assets/css//animate-3.3.0.min.css'
import '@/assets/js/jquery-2.1.4.min.js'
import '@/assets/js/jquery.cookie.js'
import '@/assets/js/jquery.base64.js'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$axios = axios
import mainMenu from './components/index/main-menu'
import slider from 'vue-concise-slider'
import store from './store/index'
Vue.prototype.is_api = process.env.API_ROOT == '/api' ? 'api/' : ''
Vue.config.productionTip = false
var src = window.location.href;//获取网页地址
var temp_count = 0
var urls = ""
for (var i = 0, k; i < src.length; i++) {
  urls = urls + src[i]
  if (src[i] == "/") {
    temp_count++
    if (temp_count == 3) {
      // 截取第三个/之前的域名
      axios.defaults.baseURL = urls.indexOf("localhost") == -1 ? urls + "xuou/public/index.php/" : process.env.API_ROOT
    }
  }
}
new Vue({
  components: { mainMenu, slider, },
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
Vue.prototype.$message1 = function (msg) {
  this.$message({
    message: msg,
    duration: 2000,
    offset: 400
  })
}


// WEBPACK FOOTER //
// ./src/main.js